import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import GraphicCombinationMedia from './GraphicCombination-media'
import { RichText, Link } from "@sitecore-jss/sitecore-jss-react";
import { PrimaryButton } from "../../elements";
import { gtag } from "../../utils";
import { mobileIs, loadScrollMagic, getOverallSettingsClasses, componentId } from "../../utils/siteUtils";

import "./style.scss";
let globalActiveIndex = -1; 
let globalInitActive = false; 
const GraphicCombination = ({ page, lang, rendering, fields, params }) => {
  const  { list  } = fields;
  const { Variant, showTextOnImage } = params;
  const rootEl = useRef();
  const mainEl = useRef();
  const titleEl = useRef();
  const subTitleEl = useRef();
  const btnEl = useRef();
  const isAR = page?.fields?.rtl?.value;
	const [activeIndex, setActiveIndex] = useState(0);
	const [oldActiveIndex, setOldActiveIndex] = useState('-1');
	const [direction, setDirection] = useState('FORWARD');
	const [initActive, setInitActive] = useState(false);
  const isMobile = mobileIs();
  useEffect(() => {
    let ScrollMagic, controller, controller2, scene, scene2;
    ScrollMagic = loadScrollMagic();

    controller = new ScrollMagic.Controller();
    controller2 = new ScrollMagic.Controller();
    scene = new ScrollMagic.Scene({
      triggerElement: mainEl.current,
      triggerHook: 0,
      duration: `${list.length}00%`,
    })
    .setPin(rootEl.current).addTo(controller);
    
    scene.on("progress", function(event) {
      let ep = event.progress;
      let es = event.scrollDirection;
      var base = 1/list.length;
      if(es === 'FORWARD'){
        for( var i=0;i<list.length;i++){
          if(ep > (base * (i+1)) && ep < (base * (i+2)) ){
            tab(i+1,i,'FORWARD')
          }
        }
      }
      if( es === 'REVERSE' ){
        for( var i=0;i<list.length;i++){
          if(ep > (base * i) && ep < (base * (i+1)) ){
            tab(i,i+1,'REVERSE')
          }
        }
      }
    })
    scene2 = new ScrollMagic.Scene({
      triggerElement: rootEl.current,
      triggerHook: 'onLeave',
      offset:10,
      duration: `${list.length}00%`,
    }).addTo(controller2);
    scene2.on("progress", function(event) {
      let ep = event.progress;
      let es = event.scrollDirection;
      let dom = document.querySelector('.GraphicCombination');
      let domItem = document.getElementsByClassName('GraphicCombination-list-item')[globalActiveIndex];
      if(dom && domItem){
        if(isMobile){
          if(es === 'FORWARD' && ep === 1){
            // dom.style.marginBottom = -window.innerHeight + domItem.clientHeight + 20 + 'px'
          }else{
            dom.style.marginBottom = '0'
          }
        }else{
          if(es === 'FORWARD' && ep === 1){
            // dom.style.marginBottom = '-16.5vh'
          }else{
            dom.style.marginBottom = '0'
          }
        }
      }
    })
    if(isMobile && Variant === 'radius'){
      window.removeEventListener("scroll", onScroll);
      scene && scene.destroy(true);
      scene = null;
      controller && controller.destroy(true);
      controller = null;
    }
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      scene && scene.destroy(true);
      scene = null;
      controller && controller.destroy(true);
      controller = null;
    }
  }, []);
  const tab = (index, oldIndex, direction) => {
    setInitActive(false)
    globalActiveIndex = index
    setDirection(direction)
    setOldActiveIndex(oldIndex)
    setActiveIndex(index)
  }
	const linkClk = () => {
		gtag('event', 'Component_info', {
		  'component_name': 'GraphicCombination',
		  'page_title': page?.name
		});
	};
  const onScroll = () => {
    if(rootEl.current ){
      let top = rootEl.current.getBoundingClientRect().top;
      let rightIcon = document.querySelectorAll('.c-sticky-button')[0];
      let topMain = mainEl.current.getBoundingClientRect().top;
      let height = rootEl.current.getBoundingClientRect().height;
      if( Math.abs(top) > height && top<0){
        setActiveIndex(list.length-1)
        globalActiveIndex = list.length-1
      }
      let autoplay ;
      let dom ;
      if( globalActiveIndex == -1) {
        autoplay = list[0].fields.autoPlay.value;
        dom = document.getElementById('video'+0);
      }else{
        autoplay = list[globalActiveIndex]?.fields?.autoPlay?.value;
        dom = document.getElementById('video'+globalActiveIndex);
      }
      if(Math.abs(top) < height*0.7 && top>0 && !globalInitActive){
        setInitActive(true)
        globalInitActive = true
      }
      if(Math.abs(topMain) < 100 && topMain<0 && !isMobile && rightIcon){
        if(!isAR){
          rightIcon.style.right = "21px";
        }
      }
      if(Math.abs(top) > height*0.7 && top>0){
        setInitActive(false)
        globalInitActive = false
      }
      if( Math.abs(top) < height && top<0 && autoplay){
				if(dom){
          dom.getElementsByTagName('video')[0].play()
					dom.classList.add("vjs-has-started")
				}
      }
      if(Math.abs(top) < height && top>0 && autoplay){
				if(dom){
          dom.getElementsByTagName('video')[0].play()
					dom.classList.add("vjs-has-started")
				}
      }
      if( Math.abs(top) > height && top<0){
        setActiveIndex(list.length-1)
				if(dom){
          dom.getElementsByTagName('video')[0].pause()
          setInitActive(false)
          globalInitActive = false
        }
      }
    }
  }
  const rootId = componentId(rendering);
  const rootClasses = classNames("GraphicCombination", getOverallSettingsClasses(fields));
  if (Variant === 'radius') {
    return (
      <div className={classNames(rootClasses, { radius: Variant === 'radius' })} datasourceid={rendering.dataSource} ref={mainEl} id={rootId}>
        <div ref={rootEl} className="GraphicCombination-list">
          {
            list.map( (item, index) => (
              <div className={classNames("GraphicCombination-list-item", 
              item.fields.autoPlay.value ? 'autoplay' : 'none',
             !isMobile && index == 0 && initActive ? 'initActive' : null,
             !isMobile && activeIndex === index && direction == 'FORWARD' ? 'active': null,
             !isMobile && activeIndex === index && direction == 'REVERSE' ? 'activeReverse': null,
              index === oldActiveIndex ?'oldeActive': null, 
              )} key={index} >
                <div className="GraphicCombination-list-item-right">
                  <GraphicCombinationMedia data={item} index={index} activeIndex={activeIndex} oldActiveIndex={oldActiveIndex}></GraphicCombinationMedia>
                  {
                    showTextOnImage && <RichText  className="text-on-image" field={isMobile ?  item?.fields?.textOnImageMobile : item?.fields?.textOnImage}></RichText>
                  }
                </div>
                <div className="GraphicCombination-list-item-left">
                  <div className="title"  ref={index==0 ? titleEl : null}>
                    <RichText field={isMobile ? item.fields.titleMobile: item.fields.title} />
                  </div>
                  <div className="subTitle"  ref={index==0 ? subTitleEl : null}>
                    <RichText field={isMobile ? item.fields.subTitleMobile : item.fields.subTitle} />
                  </div>
                  { (item.fields.buttons?.length > 0 || item.fields.button?.fields) && 
                    <div 
                      className={classNames("btn", {
                        'btn-multiple': item.fields.buttons?.length > 0,
                        'btn-horizontal': item.fields.buttonsDirection?.fields?.key?.value === 'horizontal',
                        'btn-vertical': item.fields.buttonsDirection?.fields?.key?.value === 'vertical'
                      })} 
                      ref={index==0 ? btnEl : null}
                    >
                      {item.fields.buttons?.length > 0 ? (
                        item.fields.buttons.map((btnItem, btnIndex) => (
                          <Link key={btnIndex} field={btnItem.fields?.link} onClick={(e) => linkClk()}>
                            <PrimaryButton {...btnItem.fields} />
                          </Link>
                        ))
                      ) : (
                        <Link key={index} field={item.fields.button?.fields.link} onClick={(e) => linkClk()}>
                          <PrimaryButton ref={index==0 ?btnEl : null}  {...item.fields.button?.fields} />
                        </Link>
                      )}
                    </div>
                  }
                </div>
              </div>
            ))
          }
        </div>
        <div className="GraphicCombination_bg"></div>
      </div>
    )
  };
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={mainEl} id={rootId}>
      <div ref={rootEl} className="GraphicCombination-list">
        {
          list.map( (item, index) => (
            <div className={classNames("GraphicCombination-list-item", 
            item.fields.autoPlay.value ? 'autoplay' : 'none',
            index == 0 && initActive ? 'initActive' : null,
            activeIndex === index && direction == 'FORWARD' ? 'active': null,
            activeIndex === index && direction == 'REVERSE' ? 'activeReverse': null,
            index === oldActiveIndex ?'oldeActive': null, 
            )} key={index} >
              <div className="GraphicCombination-list-item-right">
                <GraphicCombinationMedia data={item} index={index} activeIndex={activeIndex} oldActiveIndex={oldActiveIndex}></GraphicCombinationMedia>
                {
                  showTextOnImage && <RichText  className="text-on-image" field={isMobile ?  item?.fields?.textOnImageMobile : item?.fields?.textOnImage}></RichText>
                }
              </div>
              <div className="GraphicCombination-list-item-left">
                <div className="title"  ref={index==0 ? titleEl : null}>
                  <RichText field={isMobile ? item.fields.titleMobile: item.fields.title} />
                </div>
                <div className="subTitle"  ref={index==0 ? subTitleEl : null}>
                  <RichText field={isMobile ? item.fields.subTitleMobile : item.fields.subTitle} />
                </div>
                { (item.fields.buttons?.length > 0 || item.fields.button?.fields) && 
                  <div 
                    className={classNames("btn", {
                      'btn-multiple': item.fields.buttons?.length > 0,
                      'btn-horizontal': item.fields.buttonsDirection?.fields?.key?.value === 'horizontal',
                      'btn-vertical': item.fields.buttonsDirection?.fields?.key?.value === 'vertical'
                    })} 
                    ref={index==0 ? btnEl : null}
                  >
                    {item.fields.buttons?.length > 0 ? (
                      item.fields.buttons.map((btnItem, btnIndex) => (
                        <Link key={btnIndex} field={btnItem.fields?.link} onClick={(e) => linkClk()}>
                          <PrimaryButton {...btnItem.fields} />
                        </Link>
                      ))
                    ) : (
                      <Link key={index} field={item.fields.button?.fields.link} onClick={(e) => linkClk()}>
                        <PrimaryButton ref={index==0 ?btnEl : null}  {...item.fields.button?.fields} />
                      </Link>
                    )}
                  </div>
                }
              </div>
            </div>
          ))
        }
      </div>
      <div className="GraphicCombination_bg"></div>
    </div>
  )
};
export default GraphicCombination;
